module.exports = __webpack_public_path__ + "img/Consumer HSA Knowledge Infographic.718d6b35.png";